<template>
  <div class="loginOut por">
    <div class="login_inner poa" style="left:48%;top:5%">
      <div class="poa" style="left:42%;top:5%;">
        <el-image style="width: 85%" :src="require('@/img/LOGO.png')"></el-image>
      </div>
      <div class="poa" style="left:30%;top:30%;z-index:2">
        <el-image style="width: 65%" :src="require('@/img/t2.png')"></el-image>
      </div>
      <div class="poa" style="left:2%;width: 350px;">
        <div class="logo">
          <el-image style="width: 85%" :src="require('@/img/t1.png')"></el-image>
        </div>

        <div class="login_input">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px" class="demo-ruleForm">
            <el-form-item label="" prop="username">
              <el-input v-model="ruleForm.username" placeholder="请输入账号"></el-input>
            </el-form-item>
            <el-form-item label="" prop="password">
              <el-input type="password" v-model="ruleForm.password" placeholder="请输入密码"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div style="padding-top:50px;margin: 0 auto;width:90%">
          <el-image style="width: 95%;margin-left: 2.5%;cursor: pointer;" :src="require('@/img/btn.png')"
            @click="login"></el-image>
        </div>
        <!-- <el-button class="login_btn" @click="login">登录</el-button> -->
      </div>
    </div>
  </div>
</template>

<script>
import { loginByUsername, getUserinfo } from "@/api/login";
import { encrypt } from "@/api/lanmax-web-common";
export default {
  name: "login",
  data() {
    return {
      ruleForm: {
        username: "",
        password: ""
      },
      rules: {
        username: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }]
      },
      committing: false,
      // 验证码倒计时
      times: 0
    };
  },
  methods: {
    getCode() {
      const _that = this;
      _that._initTCaptcha({
        CaptchaAppId: "2092375892",
        success: function (data) {
          const obj = {
            randstr: data.randstr,
            captchaAppId: data.appid,
            ticket: data.ticket
          };
          _that.handleGetCode(obj);
        }
      });
    },
    login() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const obj = {
            username: this.ruleForm.username,
            password: this.ruleForm.password
          };
          const _that = this
          const user = encrypt(obj);
          // 极验 验证
          this._initTCaptcha({
            CaptchaAppId: "2092375892",
            success: function (data) {
              const obj = {
                randstr: data.randstr,
                captchaAppId: data.appid,
                ticket: data.ticket
              }
              _that.handleLoginByUsername(user, obj)
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 登录接口
    handleLoginByUsername(user, cap = null) {
      loginByUsername({
        username: "PWD@" + user.username + "@backstage",
        password: user.password,
        code: user.code,
        randstr: cap ? cap.randstr : '',
        captchaAppId: cap ? cap.captchaAppId : '',
        ticket: cap ? cap.ticket : '',
        grant_type: "password",
        scope: "server"
      })
        .then(res => {
          console.log(res);
          this.loginDispatch(res);
        })
        .catch(e => {
          this.$message.error(e.response.data.msg);
        });
    },
    loginDispatch(res) {
      const result = res.data;
      localStorage.setItem("partnerplan_access_token", result.access_token);
      this.$message.success("登陆成功");
      this.handleGetUser();
    },
    handleGetUser() {
      getUserinfo().then(res => {
        const result = res.data;
        if (result.code == 0) {
          sessionStorage.setItem("user", JSON.stringify(result.data));
          this.$router.push("/");
        }
      });
    },
    /**
     *
     * 腾讯校验
     *
     *
     *
     */
    _initTCaptcha(opction) {
      console.log(opction);
      let captcha = new TencentCaptcha(opction.CaptchaAppId, function (res) {
        if (res.ret === 0) {
          opction.success(res);
        }
      });
      captcha.show();
    }
  }
};
</script>

<style scoped>
.poa {
  position: absolute;
}

.por {
  position: relative;
}

.pof {
  position: fixed;
}

.loginOut {
  background: url("../img/bg1.jpg") no-repeat;
  background-size: cover;
  position: fixed;
  width: 100%;
  height: 100%;
}

.login_inner {
  background: url("../img/bg2.png") no-repeat;
  background-size: 60% 80%;
  /* background-size: cover; */
  width: 1500px;
  height: 800px;
  padding-top: 4%;
  margin-top: 3%;
}

.logo {
  width: 80%;
  margin: 0 auto;
  padding-top: 10%;
}

.login_input {
  padding: 80px 30px 0;
  width: 100%;
}

.login_btn {
  margin-top: 10.85%;
  width: 100%;
  background: #a03324;
  color: white;
  font-size: 16px;
}

.input_class {
  margin: 0 auto;
  width: 75%;
  position: relative;
}

.input_icon {
  position: absolute;
  width: 32px;
  height: 32px;
  z-index: 9999;
  top: 10%;
  left: 4.37%;
}

/* .input_class >>> .el-input__inner {
  padding-left: 65px;
} */
</style>



// WEBPACK FOOTER //
// src/views/login.vue